import { z } from 'zod';

export const LinkPolicySchema = z.enum(['vendor_origins', 'copy_only', 'confirm']);
export type LinkPolicy = z.infer<typeof LinkPolicySchema>;

export const DisplayModeSchema = z.enum(['floating', 'inline']);
export type DisplayMode = z.infer<typeof DisplayModeSchema>;

export const ColorSchemeSchema = z.enum(['light', 'dark', 'auto']);
export type ColorScheme = z.infer<typeof ColorSchemeSchema>;

const cssValue = z
  .string()
  .max(200)
  .regex(/^[^;{}<>\\]*$/, 'must not contain ; { } < > or backslashes')
  .refine((value) => !/url\s*\(|expression\s*\(|@import/i.test(value), 'must not reference a URL');

export const AppearanceVariablesSchema = z
  .object({
    colorPrimary: cssValue,
    colorBackground: cssValue,
    colorText: cssValue,
    colorDanger: cssValue,
    fontFamily: cssValue,
    fontSizeBase: cssValue,
    borderRadius: cssValue,
    spacingUnit: cssValue,
  })
  .partial();
export type AppearanceVariables = z.infer<typeof AppearanceVariablesSchema>;

export const AppearanceSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  variables: AppearanceVariablesSchema.optional(),
});
export type Appearance = z.infer<typeof AppearanceSchema>;

export const OriginSchema = z
  .string()
  .max(255)
  .regex(
    /^https?:\/\/[a-z0-9.-]+(?::\d{1,5})?$/i,
    'expected an origin such as https://app.example.com',
  )
  .refine((value) => {
    try {
      return new URL(value).origin === value.toLowerCase();
    } catch {
      return false;
    }
  }, 'expected a bare origin with no path, query or trailing slash');
